class Quote_Card {
  constructor(el) {
    this.el = el;
    this.media = this.el.closest('.media_block');

    if(!this.media) return;

    this.maxHeight = (this.el.getAttribute('data-max-height') || 100) / 100;
    this.maxWidth = (this.el.getAttribute('data-max-width') || 100) / 100;

    // this.setQuoteCardState();

    // this.debouncer = null;
    // window.addEventListener('resize', () => {
    //   if (this.debouncer) clearTimeout(this.debouncer);
    //   this.debouncer = setTimeout(() => {
    //     this.setQuoteCardState();
    //   }, 100);
    // });
  }

  // Set the state of the quote card based on how much space is available
  // in the parent media block
  setQuoteCardState() {
    const mediaBlockWidth = this.media.offsetWidth;
    const mediaBlockHeight = this.media.offsetHeight;
    const quoteCardWidth = this.el.offsetWidth;
    const quoteCardHeight = this.el.offsetHeight;

    // if is in a slider and on mobile view, force the quote card to stack
    if (!!this.media.closest('.splide__slide') && window.innerWidth < 991){
      // this.media.classList.add('force_stack_quote_card');
      return;
    }

    this.media.classList.remove('force_stack_quote_card');

    setTimeout(() => {
      if((mediaBlockWidth * this.maxWidth) < quoteCardWidth 
      || (mediaBlockHeight * this.maxHeight) < quoteCardHeight) {
        // this.media.classList.add('force_stack_quote_card');
      }
    }, 100);
  }
}

export const InitQuoteCards = () => {
  // Disabled for now.
  
  // const quoteCards = document.querySelectorAll('.quote_card');

  // if (quoteCards.length) {
  //   quoteCards.forEach((el) => {
  //    const card = new Quote_Card(el);
  //   });
  // }
}